module.exports = __webpack_public_path__ + "img/DE00121.6c43195c.png";